module.exports = __webpack_public_path__ + "img/symbol_6.c80caa64.png";